import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p450177833165213696',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
